@let works = store.works();
@if (works === null) {
    <app-loading></app-loading>
} @else if (works.length) {
    <p-table [value]="works">
        <ng-template pTemplate="header">
            <tr class="table-header">
                <th></th>
                <th>
                    {{ 'workData.doctorRecord.fields.dateFrom' | translate }}
                </th>
                <th>
                    {{ 'workData.common.enum.type.label' | translate }}
                </th>
                <th>
                    {{ 'workData.doctorRecord.fields.users' | translate }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr class="table-body">
                <td (click)="navigateWork(item)">
                    <app-button
                        [rounded]="true" [text]="true" [plain]="true"
                        severity="primary" icon="pi-folder-open"
                    ></app-button>
                </td>
                <td>{{ item.dateFrom | shortDate }}</td>
                <td>{{ 'workData.common.enum.type.' + item.workType | translate }}</td>
                <td>
                    <app-user-chip [user]="item.users[0]"></app-user-chip>
                </td>
            </tr>
        </ng-template>
    </p-table>
} @else {
    <div class="flex">
        <div class="m-2">{{ 'folderMedication.noWorks' | translate }}</div>
    </div>
}
